import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About Me`}</h2>
    <p>{`Hi. I am a MERN Stack developer (Fresher),from Ghaziabad, I have done my master Degree in Computer Application.`}</p>
    <p>{`It all started in 2020 where I first learnt to build static landing pages.
Then I came to know about how servers work with the help of Python,Java and now currently Node.js.
That expanded my view upon the possibilities of creating huge applications`}</p>
    <p>{`Then I slowly started engaging myself building single page application development Using React,
state management techniques using Redux.js and Context API and sideeffects using Redux-thunk
and Redux-Saga,Node.js and Express.js and knowing how to connect to databases using MongoDB.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      